module.exports = __webpack_public_path__ + "img/logo.aaf44079.png";